import React from "react";
import { Container } from "shards-react";

/**
 * Shown when required environment variables are missing in production.
 */
const Misconfiguration = () => (
  <Container fluid className="main-content-container px-4 pb-4 d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
    <div className="text-center text-muted">
      <h2>Misconfiguration</h2>
      <p className="mb-0">
        Required configuration is missing. Please set the necessary environment variables (e.g. REACT_APP_BASE_URL) and rebuild.
      </p>
    </div>
  </Container>
);

export default Misconfiguration;
